"use strict";

var Button, ButtonToolbar, DisableOnSubmitMixin, Form, ParserMixin, React, classnames, map, ref;

React = require("react");

classnames = require("classnames");

ParserMixin = require("./mixins/Parser");

DisableOnSubmitMixin = require("../controls/mixins/DisableOnSubmit");

map = require("lodash/map");

ref = require("react-bootstrap"), ButtonToolbar = ref.ButtonToolbar, Button = ref.Button;

Form = React.createClass({
  displayName: "Form",

  mixins: [ParserMixin, DisableOnSubmitMixin],
  propTypes: {
    formDef: React.PropTypes.object,
    formData: React.PropTypes.object,
    title: React.PropTypes.string,
    onEnter: React.PropTypes.func,
    buttons: React.PropTypes.object
  },
  classes: function classes() {
    return classnames({
      "form-horizontal": true,
      "component-submitting": this.props.submitting,
      "component-not-submitting": !this.props.submitting
    });
  },
  buttons: function buttons() {
    return map(this.props.buttons, (function (_this) {
      return function (props, title) {
        props.key = title;
        props.disabled = _this.disabled();
        return React.createFactory(Button)(props, title);
      };
    })(this));
  },
  render: function render() {
    return React.createElement(
      "form",
      { role: "form", className: this.classes(), onChange: this.onChange },
      this.constructFormFromDef(this.props.formDef),
      React.createElement(
        ButtonToolbar,
        null,
        this.buttons()
      )
    );
  }
});

module.exports = Form;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/containers/Form.js
 ** module id = 164
 ** module chunks = 0
 **/